import { t } from "@/i18n-js/instance";
import { BlockListItem } from "../BlockListItem";

export const CallToActionItem = () => (
  <BlockListItem
    icon="16-call-to-action"
    label={t("courses.lockscreen.call_to_action")}
  />
);
